import React from 'react';
import { FormActualResidenceVM } from 'practice/view-models/pratice-actual-residence';
import { useEventCallback } from '@mui/material';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import { PracticeEditResidence } from 'practice/view-models/practice-edit-residence';
import ItalianForm from '../accordion-actual-residence/italian';
import { ItalianVM } from 'shell/view-models/register-office-practice-vm';

interface PracticeTemporaryActualResidenceComponentProps {
  ForPracticeTemporary?: boolean;
}
const PracticeTemporaryActualResidenceComponent = ({
  ForPracticeTemporary,
}: PracticeTemporaryActualResidenceComponentProps): React.ReactElement => {
  const formContext = useFormikContext<PracticeEditResidence>();

  const onChangeItalian = useEventCallback(
    (key: keyof ItalianVM, value: ItalianVM[keyof ItalianVM]) => {
      formContext.setFieldValue('residence', {
        ...(formContext.values.residence || {}),
        italian: {
          ...(formContext.values.residence?.italian || {}),
          [key]: value,
        },
      });
    }
  );

  const onChangesItalian = useEventCallback((values: ItalianVM) => {
    formContext.setFieldValue('residence', {
      ...(formContext.values.residence || {}),
      italian: {
        ...(values || {}),
      },
    });
  });

  return (
    <>
      <ItalianForm
        onChange={onChangeItalian}
        onChanges={onChangesItalian}
        ForPracticeTemporary={ForPracticeTemporary}
        errors={
          (formContext?.errors?.residence as unknown as FormikErrors<FormActualResidenceVM>)
            ?.italian as unknown as FormikErrors<ItalianVM>
        }
        touched={
          (formContext?.touched?.residence as unknown as FormikTouched<FormActualResidenceVM>)
            ?.italian as unknown as FormikTouched<ItalianVM>
        }
        values={formContext?.values?.residence?.italian}
      />
    </>
  );
};

PracticeTemporaryActualResidenceComponent.displayName =
  'Practice Temporary Actual ResidenceComponent;';

const PracticeTemporaryActualResidence = React.memo(PracticeTemporaryActualResidenceComponent);
export default PracticeTemporaryActualResidence;
